var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTransfer = function SvgIconTransfer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.805 4.651L13.304.189a.648.648 0 0 0-.91 0 .634.634 0 0 0-.188.45v1.913H7.705a.64.64 0 0 0-.643.638.64.64 0 0 0 .643.637h5.144a.64.64 0 0 0 .643-.637V2.178l2.949 2.924-2.949 2.924V7.015a.64.64 0 0 0-.643-.638H5.776V4.465a.64.64 0 0 0-.643-.638.643.643 0 0 0-.454.187L.178 8.477a.633.633 0 0 0 0 .901l4.501 4.463a.647.647 0 0 0 .701.138.637.637 0 0 0 .396-.589v-1.913h4.501a.64.64 0 0 0 .643-.637.64.64 0 0 0-.643-.638H5.133a.64.64 0 0 0-.643.638v1.011L1.542 8.927 4.49 6.004v1.011a.64.64 0 0 0 .643.637h7.073v1.913a.64.64 0 0 0 .643.637.65.65 0 0 0 .455-.186l4.501-4.463a.634.634 0 0 0 0-.902z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-transfer.576d678c.svg";
export { ForwardRef as ReactComponent };